import { Factory } from 'miragejs'
import { faker } from '@faker-js/faker'
import { formatISO } from 'date-fns'

export default Factory.extend({
  name(i) {
    const className = faker.helpers.arrayElement('ABCDEFGHIJKLMNOPQRSTUVWXYZ')
    return `Class ${i}-${className}`
  },

  mathseedsPrimeAccess: true,

  playroomAccess() {
    return faker.datatype.boolean()
  },
  gamesAccess() {
    return faker.datatype.boolean()
  },

  backgroundMusicDisabled() {
    return faker.datatype.boolean()
  },

  createdAt() {
    return formatISO(faker.date.recent({ days: 500 })) // in the last 500 days
  },
})
